import { useSessionUser, useToken } from '@/store/authStore';
import type { AxiosError } from 'axios';

const unauthorizedCode = [401, 419, 440];

const AxiosResponseIntrceptorErrorCallback = (error: AxiosError) => {
  const { response } = error;
  const { setToken } = useToken();

  if (response && unauthorizedCode.includes(response.status)) {
    setToken('');
    useSessionUser.getState().setUser(null);
    useSessionUser.getState().setSessionSignedIn(false);
    useSessionUser.getState().setTenantId('');
  }
};

export default AxiosResponseIntrceptorErrorCallback;
